import { resourceText } from 'src/app/shared/services/localization';
import { AfterViewInit, Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { Notification } from 'src/app/shared/models/notification.model';
import { GlobalService } from 'src/app/shared/services/global.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-push-notifications',
    templateUrl: './push-notifications.component.html',
    styleUrls: ['./push-notifications.component.scss'],
    standalone: false
})
export class PushNotificationsComponent implements OnInit, AfterViewInit {

  userId: string = '';
  notifications: Notification[] = [];
  loadError = false;
  deleteError = false;
  deleting = false;
  unreadOnly = false;
  confirmDelete: boolean = false;
  isLoading: boolean = true;
  constructor(@Inject(LOCALE_ID) private locale: string, public globalService: GlobalService,
              private notificationService: NotificationService,
              private router: Router
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    this.loadError = false;
    this.notifications = [];
    try {
      this.userId = localStorage.getItem('CSBarcodeID');
      if (!this.userId || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(this.userId)) { this.userId = ''; return; }
      const notifications = await this.notificationService.viewNotifications(this.userId);
      this.notifications = Array.isArray(notifications) ? notifications : [];
      this.notifications.forEach(a => {
        const date = new Date(a.notificationDate);
        a['receivedAt'] = a.notificationDate && !isNaN(date.getTime()) ? a.notificationDate : '';
        a.notificationDate = a.notificationDate && !isNaN(date.getTime()) ? formatDate(date, 'MM/dd/yy', this.locale).trim() : '';
        a['selected'] = false;
      });
    } catch {
      this.loadError = true;
    } finally {
      this.isLoading = false;
    }
  }

  ngAfterViewInit(): void {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.selectedOption = "NOTIFICATIONS";
    this.globalService.screenHeader = resourceText('NOTIFICATION');
  }

  signIn(): void {
    const tenant = localStorage.getItem('tenant') || this.globalService.currentTenant;
    void this.router.navigate(['/' + tenant + '/login'], {queryParams:{returnUrl:'/' + tenant + '/notifications'}});
  }

  ToggleSelection(notification)
  {
    notification.selected = !notification.selected;
  }

  ApplySelectOperation() {
    const select = !this.isAllSelected();
    this.visibleNotifications.forEach(item => item['selected'] = select);
  }

  getSelectOperationText()
  {
    if (this.isAllSelected() == true)
      return this.globalService.Get("UNSELECTALL");
    else
      return this.globalService.Get("SELECTALL");
  }

  isAllSelected() {
    return this.visibleNotifications.length > 0 && this.visibleNotifications.every(item => item['selected']);
  }

  isAnySelected() {
    return (this.notifications?.findIndex(a => a["selected"] == true) >= 0);
  }

  getSelectedCount() {
    let selectionCount = this.notifications?.filter(a => a["selected"]).length;
    let totalCount = this.notifications?.length;
    return resourceText('SELECTED_NOTIFICATIONS_VALUE0_VALUE1', {value0:(selectionCount),value1:(totalCount)});
  }

  openNotification(notification) {
    notification.isOpen = true;
    this.router.navigate(['/admin/cms/notification/' + notification?.messageUUID ]);
  }

  get unreadCount(): number { return this.notifications.filter(item => !item.isOpen).length; }
  get visibleNotifications(): Notification[] { return this.unreadOnly ? this.notifications.filter(item => !item.isOpen) : this.notifications; }
  trackNotification(index: number, item: Notification): string | number { return item.messageUUID || item.id || index; }

  async deleteSelection() {
    if (this.deleting || !this.isAnySelected()) return;
    const selected = this.notifications.filter(item => item['selected']).map(item => item.messageUUID);
    this.deleting = true;
    this.deleteError = false;
    try {
      const result = await this.notificationService.deleteNotifications(this.userId, selected);
      if (result !== 'success') throw new Error('Notification delete was not confirmed');
      this.notifications = this.notifications.filter(item => !selected.includes(item.messageUUID));
      this.confirmDelete = false;
    } catch { this.deleteError = true; this.confirmDelete = false; }
    finally { this.deleting = false; }
  }
}
